import { TableAlign } from '../../../components/Table'
import { SortableColumn } from '../../../hooks/use-sort-data'

export interface FormCategoryItem {
  id: string
  value: string | null
  label: string
  forms: string[]
}

export interface FilingItem {
  filingDate?: string
  form?: string
  reportDate?: string
  filingRootUrl?: string
  primaryDocumentUrl?: string
  interactive: boolean
  accessionNumber: number
}

export type SerializedLatestFilingsData = {
  items: FilingItem[]
  formCategories: FormCategoryItem[]
  descriptions: Record<string, string>
}

export interface ParsedFilingItem {
  filingDate?: Date
  form?: string
  description?: string
  reportDate?: Date
  filing?: string
  document?: string
  accessionNumber: number
}

export type ParsedLatestFilingsData = {
  items: ParsedFilingItem[]
  formCategories: FormCategoryItem[]
}

export enum ColumnId {
  FilingDate = 'filingDate',
  ReportDate = 'reportDate',
  Form = 'form',
  Description = 'description',
  Filing = 'filing',
  Document = 'document',
  AccessionNumber = 'accessionNumber',
}

export interface TableColumnDefinition extends SortableColumn<ColumnId, ParsedFilingItem> {
  name: string
  align?: TableAlign
  className?: string
  renderColumn: (props: ParsedFilingItem) => React.ReactNode
  sortable?: boolean
  hidden?: boolean
}
